import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  footerColumns = [
    {
      title: 'Términos legales',
      items: [
        {
          label: 'Políticas de privacidad',
          url: '/politicas-de-privacidad',
        },
        {
          label: 'Términos y condiciones',
          url: '/terminos-y-condiciones',
        },
        {
          label: 'V 3.2.20',
          url: '/',
        },
      ],
    },
    {
      title: 'Acerca de la empresa',
      items: [
        {
          label: '¿Quiénes somos?',
          url: '/quienes-somos',
        },
      ],
    },
    {
      title: 'Ayuda',
      items: [
        {
          label: 'Contáctanos',
          url: '/contactanos',
        },
        {
          label: 'Métodos de pago',
          url: '/metodos-de-pago',
        },
        {
          label: 'Cancelaciones y devoluciones',
          url: '/cancelaciones-y-devoluciones',
        },
      ],
    },
    {
      title: 'Redes sociales',
      items: [
        {
          icon: 'bx bxl-instagram icon',
          label: '@universotunning',
          url: 'https://www.instagram.com/universotunning',
        },
        {
          icon: 'bx bxl-facebook-square icon',
          label: 'universotunning',
          url: 'https://www.facebook.com/universotunning',
        },
        {
          icon: 'bx bxl-whatsapp icon',
          label: '+5492617588255 (mayoristas)',
          url: 'https://wa.me/5492617588255',
        },
        {
          icon: 'bx bx-envelope icon',
          label: 'universotunning@gmail.com',
          url: 'mailto:universotunning@gmail.com',
        },
      ],
    },
  ];
}
